import { useState } from "react";
import { TextField } from "@material-ui/core";
const FielBusqueda = (props) =>{
    const {setBusqueda = ()=>{}, label = "Buscar"} = props
    const [buscador, setBuscador] = useState("")
    const onChange = (event) =>{
        setBusqueda((event.target.value.length > 0) ? event.target.value : "0")
        setBuscador((event.target.value.length > 0) ? event.target.value : "")
    }
    return (
        <TextField
        id="FielBusqueda"
        label={label}
        variant="outlined"
        name="busqueda"
        style={{ width: "100%", margin: "5px 0" }}
        value={buscador}
        onChange={(e) => onChange(e)}
      />
    )
}
export default FielBusqueda;